import { Observable } from "./utils/observable";

export class ErrorStore {
  public error = new Observable<Error | null>(null);
}
